// Icon.jsx — utilitarian line icons. <Icon name size stroke color/>
// Stroke-based, currentColor by default.
import React from 'react';

const ICON_PATHS = {
  // nav
  today: '<rect x="3" y="4.5" width="18" height="16" rx="2"/><path d="M3 9h18M8 2.5v4M16 2.5v4"/><path d="M7.5 13.5l1.6 1.6 3-3.2"/>',
  list: '<path d="M8 6h13M8 12h13M8 18h13"/><circle cx="3.5" cy="6" r="1.2"/><circle cx="3.5" cy="12" r="1.2"/><circle cx="3.5" cy="18" r="1.2"/>',
  invoice: '<path d="M6 2.5h9l4 4V21a1 1 0 0 1-1.4.9L15 20.5l-2.5 1.4L10 20.5 7.4 21.9A1 1 0 0 1 6 21V2.5z"/><path d="M9 8h6M9 12h6M9 16h4"/>',
  user: '<circle cx="12" cy="8" r="3.6"/><path d="M5 20c0-3.6 3-6 7-6s7 2.4 7 6"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  // chevrons / arrows
  chevR: '<path d="M9 5l7 7-7 7"/>',
  chevL: '<path d="M15 5l-7 7 7 7"/>',
  chevD: '<path d="M5 9l7 7 7-7"/>',
  back: '<path d="M15 5l-7 7 7 7"/>',
  arrowR: '<path d="M5 12h14M13 6l6 6-6 6"/>',
  // domain
  pin: '<path d="M12 22s7-6.3 7-12a7 7 0 1 0-14 0c0 5.7 7 12 7 12z"/><circle cx="12" cy="10" r="2.6"/>',
  car: '<path d="M5 16.5h14M6.5 16.5v2M17.5 16.5v2"/><path d="M4.5 16.5l1.4-5a2 2 0 0 1 1.9-1.4h8.4a2 2 0 0 1 1.9 1.4l1.4 5"/><path d="M4.5 16.5h15"/><circle cx="8" cy="16.5" r="0"/>',
  route: '<circle cx="6" cy="18" r="2.2"/><circle cx="18" cy="6" r="2.2"/><path d="M8 16.5c4-1.5 8-3.5 8-8M9.5 6H7a2.5 2.5 0 0 0 0 5h4a2.5 2.5 0 0 1 0 5h-1"/>',
  clock: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>',
  camera: '<path d="M3 8.5a2 2 0 0 1 2-2h2l1.2-2h7.6L19 6.5h0a2 2 0 0 1 2 2V18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8.5z"/><circle cx="12" cy="13" r="3.4"/>',
  box: '<path d="M12 2.5l8 4.2v8.6L12 21.5 4 15.3V6.7l8-4.2z"/><path d="M4 6.8l8 4.2 8-4.2M12 11v10.5"/>',
  bed: '<path d="M3 8v11M3 12h18a0 0 0 0 1 0 0v7M21 19V12a3 3 0 0 0-3-3H8v3"/><circle cx="6" cy="9.5" r="1.6"/>',
  sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2v2.5M12 19.5V22M2 12h2.5M19.5 12H22M4.9 4.9l1.8 1.8M17.3 17.3l1.8 1.8M19.1 4.9l-1.8 1.8M6.7 17.3l-1.8 1.8"/>',
  tool: '<path d="M14.5 6.5a3.8 3.8 0 0 1 5 5L11 20l-4 1 1-4 6.5-6.5z"/><path d="M13 8l3 3"/>',
  wrench: '<path d="M14.7 6.3a4 4 0 0 0 5 5.2l-3-3 1.4-1.4-2.8-1a4 4 0 0 0-4.7 5.2l-6 6 2.8 2.8 6-6"/>',
  check: '<path d="M5 12.5l4.5 4.5L19 7"/>',
  checkCircle: '<circle cx="12" cy="12" r="8.5"/><path d="M8.5 12.2l2.4 2.4 4.6-4.8"/>',
  trash: '<path d="M4 6.5h16M9 6.5V4.5h6v2M6 6.5l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13M10 10v7M14 10v7"/>',
  plusCircle: '<circle cx="12" cy="12" r="8.5"/><path d="M12 8.5v7M8.5 12h7"/>',
  minus: '<path d="M5 12h14"/>',
  edit: '<path d="M4 16.5V20h3.5L18 9.5 14.5 6 4 16.5z"/><path d="M13 7.5L16.5 11"/>',
  doc: '<path d="M6 2.5h8l4 4V21a.9.9 0 0 1-.9.9H6a.9.9 0 0 1-.9-.9V3.4A.9.9 0 0 1 6 2.5z"/><path d="M13.5 2.8V7h4.2"/>',
  phone: '<path d="M6.5 3.5h3l1.2 4-2 1.3a11 11 0 0 0 5 5l1.3-2 4 1.2v3a1.5 1.5 0 0 1-1.6 1.5C10.3 21.5 3.5 14.7 3.5 6.1A1.5 1.5 0 0 1 5 4.5"/>',
  flag: '<path d="M5 21V4M5 4.5h11l-1.6 3.2L16 11H5"/>',
  play: '<path d="M7 4.5l12 7.5L7 19.5z"/>',
  navigate: '<path d="M3.5 11l17-7.5L13 20.5l-2-7-7.5-2.5z"/>',
  search: '<circle cx="11" cy="11" r="6.5"/><path d="M20 20l-3.6-3.6"/>',
  layers: '<path d="M12 3l9 5-9 5-9-5 9-5z"/><path d="M3 13l9 5 9-5M3 16.5l9 5 9-5"/>',
  x: '<path d="M6 6l12 12M18 6L6 18"/>',
  calendar: '<rect x="3" y="4.5" width="18" height="16" rx="2"/><path d="M3 9h18M8 2.5v4M16 2.5v4"/>',
  bell: '<path d="M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6z"/><path d="M10 20a2 2 0 0 0 4 0"/>',
  cog: '<circle cx="12" cy="12" r="3.2"/><path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5 5l2.1 2.1M16.9 16.9L19 19M19 5l-2.1 2.1M7.1 16.9L5 19"/>',
  chart: '<path d="M4 20V4M4 20h16M8 16v-4M12 16V8M16 16v-6"/>',
  building: '<rect x="5" y="3" width="14" height="18" rx="1"/><path d="M9 7h2M13 7h2M9 11h2M13 11h2M9 15h2M13 15h2M10 21v-3h4v3"/>',
  message: '<path d="M21 11.5a8.5 8.5 0 0 1-12.4 7.55L4 20.5l1.45-4.3A8.5 8.5 0 1 1 21 11.5z"/><path d="M8.5 11.5h7M8.5 8.5h4"/>',
  send: '<path d="M4 11.5l16-7-7 16-2.5-6.5L4 11.5z"/>',
  mail: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3.5 6.5L12 13l8.5-6.5"/>',
  scan: '<path d="M4 8V6a2 2 0 0 1 2-2h2M16 4h2a2 2 0 0 1 2 2v2M20 16v2a2 2 0 0 1-2 2h-2M8 20H6a2 2 0 0 1-2-2v-2"/><path d="M4 12h16"/>',
  receipt: '<path d="M5 3.5h14v17l-2.3-1.4-2.3 1.4-2.4-1.4-2.3 1.4L7.3 20.6 5 20.5V3.5z"/><path d="M8.5 8h7M8.5 11.5h7M8.5 15h4"/>',
  sparkle: '<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3z"/><path d="M19 15l.7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7.7-2z"/>',
  image: '<rect x="3.5" y="4.5" width="17" height="15" rx="2"/><circle cx="8.5" cy="9.5" r="1.8"/><path d="M4 17l4.5-4 3 2.5L15 11l5 5"/>',
};

function Icon({ name, size = 22, stroke = 2, color = 'currentColor', style }) {
  const d = ICON_PATHS[name];
  if (!d) return null;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round"
      style={{ display: 'block', flexShrink: 0, ...style }}
      dangerouslySetInnerHTML={{ __html: d }} />
  );
}

export { Icon, ICON_PATHS };
